import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedReorder202601: FaireAdPerformancePeriodEntity =
  {
    token: "perf_p4_under_utilized_reorder_202601",
    type: "adPerformancePeriod",
    scope: "REORDER_MARKETPLACE",
    periodType: "RECEIPT",
    startDate: "2026-01-01",
    endDate: "2026-01-31",
    impressions: 3059,
    clicks: 38,
    adsSpendDollars: 215,
    budgetDollars: 500,
    salesDollars: 873,
    bestEstimateRoas: 4.06,
    bestEstimateType: "ACTUALIZED",
    budgetUtilization: 0.43,
    reorderConversions: 3,
    dataAvailableAtDate: "2026-02-04",
    meta: {
      source: "mock",
      importedAt: "2026-07-06T00:00:00.000Z",
      importedBy: "advertiser-profiles",
    },
  };
